import { useEffect } from 'react';
import type { LectResponse } from 'src/apis/contract-management/types';
import { useAxios } from 'src/hooks/use-axios';

type HookConfig = {
  url: string;
};

type RequestOptions = {
  url: string;
};

export function useLect({ url }: HookConfig) {
  const lect = useAxios(
    (axios, baseConfig, { url }: RequestOptions) =>
      axios.request<LectResponse>({
        ...baseConfig,
        url,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    lect.execute({ url });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return lect;
}

export type LectRequest = ReturnType<typeof useLect>;
